<ng-template #editPartTypeCotacaoModal>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'support.cotacoes.modal.editar-part-type-cotacao.title' | translate: { quotationId: quotationId } }}</h4>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
    </div>
    <div class="modal-body">
        <form>
            <select-component class="type-input" [options]="types" [isMultiselect]="true" label="support.cotacoes.modal.editar-part-type-cotacao.form.label.type" [control]="typeControl" />
        </form>
    </div>
    <div class="modal-footer">
        <button id="salvar" type="submit" class="btn btn-primary" (click)="save();">{{ 'elemento.generico-botao.salvar' | translate}}</button>
        <button id="closeModal" type="button" class="btn btn-light" (click)="close();">{{ 'elemento.generico-botao.fechar' | translate}}</button>
    </div>
    <ngx-loading [show]="loading" [template]="templateEdicao"></ngx-loading>
</ng-template>
<ng-template #templateEdicao></ng-template>
